var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOptional = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 0.75C0.765625 0.75 0 1.54297 0 2.5V13C0 13.9844 0.765625 14.75 1.75 14.75H8.75C9.70703 14.75 10.5 13.9844 10.5 13V2.5C10.5 1.54297 9.70703 0.75 8.75 0.75H1.75ZM4.375 3.375H6.125C7.08203 3.375 7.875 4.16797 7.875 5.125V10.375C7.875 11.3594 7.08203 12.125 6.125 12.125H4.375C3.39062 12.125 2.625 11.3594 2.625 10.375V5.125C2.625 4.16797 3.39062 3.375 4.375 3.375ZM5.25 2.5C5.00391 2.5 4.8125 2.30859 4.8125 2.0625C4.8125 1.84375 5.00391 1.625 5.25 1.625C5.46875 1.625 5.6875 1.84375 5.6875 2.0625C5.6875 2.30859 5.46875 2.5 5.25 2.5ZM5.25 13.875C5.00391 13.875 4.8125 13.6836 4.8125 13.4375C4.8125 13.2188 5.00391 13 5.25 13C5.46875 13 5.6875 13.2188 5.6875 13.4375C5.6875 13.6836 5.46875 13.875 5.25 13.875ZM4.375 4.25C3.88281 4.25 3.5 4.66016 3.5 5.125V7.75H7V5.125C7 4.66016 6.58984 4.25 6.125 4.25H4.375Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOptional);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/optional.bdd14ec737fe3a2c9d7195d849695ce6.svg";